import clients from "shared/repositories/HttpClient";

const KanteiRestartNotifyRepository = {
  post: async (fortuneId: number): Promise<boolean> => {
    const res = await clients.miror.post("kantei_restart_notify", {
      fortuneId: fortuneId,
    });
    return res.status === 201;
  },
};

export default KanteiRestartNotifyRepository;
